var img = "data:image/svg+xml,%3csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.16336 9.4501L21.5996 9.4501L21.5996 12.1501L5.16336 12.1501L12.7234 19.7101L10.7996 21.6001L-0.000391951 10.8001L10.7996 9.82189e-05L12.7234 1.8901L5.16336 9.4501Z' fill='white' /%3e%3c/svg%3e";

export { img as default };
